/**
 * RotationPreviewPanel — renders a RotationPreviewResult: a tracker-writes
 * notice, then the swap SCHEMA (per pool: OUT ⟶ IN rows + blocked) — the same
 * schema the History view uses.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import type { RotationPreviewResult } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';
import { rotationWriteNotice } from '@/features/flow-optimizer/tabs/queue/rotation/outcome/rotation-write-notice';

import RotationSchemaView from './RotationSchemaView';

const TrackerNotice: FC<{ result: RotationPreviewResult }> = ({ result }) => (
  <p
    className={cn(
      'rounded-md border px-3 py-2 text-[11px]',
      result.trackerWritesEnabled
        ? 'border-success/40 bg-success/10 text-success'
        : 'border-warning/40 bg-warning/10 text-warning',
    )}
  >
    {rotationWriteNotice(result)}
  </p>
);

const RotationPreviewPanel: FC<{ result: RotationPreviewResult }> = ({ result }) => (
  <div className="space-y-3 rounded-md border border-border/60 bg-card/40 p-3">
    <TrackerNotice result={result} />
    {result.error ? (
      <p className="rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-[11px] text-destructive">
        {result.error}
      </p>
    ) : null}
    <RotationSchemaView diffs={result.diffs} perPool={result.perPool} />
  </div>
);

export default RotationPreviewPanel;
